import {FetchFindOrganizationTreeByOrgId} from "_private/api/public";
// import config from "@/individuation.config.js";

const common = {
    state: {
        // 模块id
        moduleId: "",
        // 组织架构
        organizations: [],
        // 默认列表页的查询框是否展开
        // 打开 false
        // 收起 true
        searchFormIsOpen: false
    },
    mutations: {
        // 设置模块id
        SET_MODULE_ID(state, moduleId) {
            state.moduleId = moduleId;
        },
        // 设置组织架构
        SET_ORGANIZATIONS(state, data) {
            state.organizations = data;
        },
        // 设置默认列表页的查询框是否展开
        SET_SEARCH_FORM_IS_OPEN(state, searchFormIsOpen) {
            state.searchFormIsOpen = true;
        }
    },
    actions: {
        setOrganizationAct({commit, state}) {
            return new Promise((resolve, reject) => {
                FetchFindOrganizationTreeByOrgId()
                    .then(response => {
                        if (
                            response.result &&
                            Array.isArray(response.result) &&
                            response.result.length > 0
                        ) {
                            commit("SET_ORGANIZATIONS", response.result);
                            resolve([...state.organizations]);
                        } else {
                            throw response;
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        setSearchFormIsOpenAct({commit}) {
            commit("SET_SEARCH_FORM_IS_OPEN", $GLOBAL_CONFIG.searchFormIsOpen);
        }
    }
};

export default common;
